<div class="page-header">
	<div class="header-copy">
		<div class="header-accent" aria-hidden="true"></div>
		<div class="header-text">
			<h2>{{ headline | translate }}@if (spaceName) { <span class="space-name">| {{ spaceName }}</span>}</h2>
			@if (subheadline) {
				<p>{{ subheadline | translate }}</p>
			}
		</div>
	</div>

	<div class="header-actions">
		<ng-content></ng-content>
	</div>
</div>
